import { createHashRouter } from 'react-router-dom';
import App from '../App';
import NotFound from '../pages/NotFound';
import InvestmentSolutions from "@/pages/InvestmentSolutions";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import WhyPrivateTech from "@/pages/WhyPrivateTech";
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import ContactUs from "@/pages/ContactUs";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Disclaimer from "@/pages/Disclaimer";
import TermsOfUse from "@/pages/TermsOfUse.tsx";

const router = createHashRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <InvestmentSolutions />,
      },
      {
        path: 'why-private-tech',
        element: <WhyPrivateTech />,
      },
      {
        path: 'blog',
        element: <Blog />,
      },
      {
        path: 'blog/:id',
        element: <BlogDetail />,
      },
      {
        path: 'login',
        element: <SignIn />,
      },
      {
        path: 'signup',
        element: <SignUp />,
      },
      {
        path: 'contact-us',
        element: <ContactUs />,
      },
      // {
      //   path: 'about',
      //   element: <AboutCard />,
      // },
      // {
      //   path: 'polaris-invest',
      //   element: <PolarisInvest />,
      // },
      // {
      //   path: 'market-data',
      //   element: <MarketData />,
      // },
      {
        path: '*',
        element: <NotFound />
      }
    ],
  },
  {
    path: 'privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: 'disclaimer',
    element: <Disclaimer />,
  },
  {
    path: 'terms-of-use',
    element: <TermsOfUse />,
  },
]);

export default router;
